export const ScheduleStore = {
    namespaced: true,
    state: {
        schedules: [],
        schedule: {}
    },
    mutations: {
        setSchedules(state: any, response: any) {
            state.schedules = response;
        },
        setScheduleId(state: any, response: any) {
            state.schedule = response;
        }
    },
    actions: {
        setSchedules(context: any, response: any) {
            context.commit('setSchedules', response);
        },
        setScheduleId(context: any, response: any) {
            context.commit('setScheduleId', response);
        }
    },
    getters: {
        getSchedule: (state: any) => state.schedules,
        getScheduleId: (state: any) => state.schedule
    },

}